import { get, includes, trim } from 'lodash';
import { host as apiHost } from 'config/api';

const LOGGED_OUT_CODES = [
  'session_invalid',
  'session_expired',
  'session_revoked',
];

/*
* Turn a failed startup request (see api.handleError) into something
* readable, instead of leaving the page on a spinner. Development only.
*/
export default (error) => {
  const code = get(error, 'error.code');

  if (includes(LOGGED_OUT_CODES, code)) {
    return {
      title: 'You\'re not logged in',
      message: 'Log in to Beacon, then come back to the admin dashboard.',
      showLoginLink: true,
    };
  }

  if (code === 'forbidden') {
    return {
      title: 'You don\'t have access to the admin dashboard',
      message: 'Ask someone with access to the Permissions tab to grant you "Admin dashboard".',
      // api-service fails closed when it can't read grants from DynamoDB,
      // so locally this usually means its AWS credentials have expired.
      hint: 'Running api-service locally? It returns this same error when it can\'t read permissions from DynamoDB, so check its AWS credentials are still valid (aws sts get-caller-identity).',
    };
  }

  // No response at all, e.g. api-service isn't running
  if (!get(error, 'httpStatus')) {
    return {
      title: 'Couldn\'t reach the Beacon API',
      message: trim(`No response from ${apiHost}. ${get(error, 'message', '')}`),
    };
  }

  return {
    title: 'The admin dashboard couldn\'t load',
    message: get(error, 'error.message') || `Request failed with status ${error.httpStatus}.`,
    hint: code ? `Error code: ${code}` : null,
  };
};
